export const loginValidationErrorType = {
  valid: 1,
  empty: 2,
  wrong: 3,
};
